import { getLineMesh } from '@/Engine/Primitives/LineMesh';
import { Quaternion, Vector3, MeshStandardMaterial, BoxGeometry, Group, Mesh } from 'three';
import { TextMesh } from '@/Engine/Ruler/TextMesh';
import { SimpleTextMesh } from '@/Engine/Ruler/SimpleTextMesh';

const lineBlackMaterial = new MeshStandardMaterial({ color: 0x000000 });
const geometry = new BoxGeometry(0.004, 1, 0.004, 3);

//TODO оберни переменные в объект, чтобы удобнее было обращаться
export function getLineMeshWithDashes(start: Vector3,
                                      end: Vector3,
                                      text: string | null = null,
                                      dashes = true,
                                      textOtherSide=false) {
    const model = new Group();

    const direction = new Vector3().subVectors(end, start);
    const lineLength = direction.length();
    direction.normalize();

    const line = new Mesh(geometry, lineBlackMaterial);

    line.scale.y = lineLength;
    line.position.set(
        (start.x + end.x) / 2,
        (start.y + end.y) / 2,
        (start.z + end.z) / 2,
    );
    const axis = new Vector3(0, 1, 0);
    const quaternion = new Quaternion().setFromUnitVectors(axis, direction);
    line.quaternion.copy(quaternion);
    model.add(line);
    const isVertical = (start.x - end.x) == 0;

    if (text) {
        const textMesh = new SimpleTextMesh(text);

        const midPoint = new Vector3();
        midPoint.addVectors(start, end).multiplyScalar(0.5);
        textMesh.model.position.copy(midPoint);
        if (isVertical) {
            textMesh.model.position.x -= 0.015;
            textMesh.model.position.y -= 0.03;
            textMesh.model.position.z=1;
            textMesh.model.rotation.z = Math.PI / 2;
            if(textOtherSide) {
                textMesh.model.position.x += 0.017;
                textMesh.model.rotation.z = -Math.PI / 2;
            }
        }
        if (!isVertical) {
            textMesh.model.position.x -= 0.05;
            textMesh.model.position.y += 0.015;
        }
        model.add(textMesh.model);
    }

    if (dashes) {
        const dashStart = new Mesh(geometry, lineBlackMaterial);
        const dashEnd = new Mesh(geometry, lineBlackMaterial);

        if (isVertical) dashStart.rotation.z = Math.PI / 2;
        dashStart.position.copy(start);
        dashStart.scale.set(1, 0.05, 1);

        if (isVertical) dashEnd.rotation.z = Math.PI / 2;
        // dashStart.quaternion.copy(quaternion);
        // dashEnd.quaternion.copy(quaternion);
        dashEnd.position.copy(end);
        dashEnd.scale.set(1, 0.05, 1);

        model.add(dashStart);
        model.add(dashEnd);
    }

    return model;
}
